module.exports = __webpack_public_path__ + "static/media/logi_mouse@2x.ae81cd92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/accesories/logi_mouse@2x.png
// module id = 326
// module chunks = 0